<template>
  <div v-if="isSuccess">
    <div
      v-if="isValidArray(items)"
      class="content"
      :style="`height: ${height}px;`"
      @scroll="loadMore"
    >
      <ul class="list">
        <li
          v-for="(item, index) in items"
          :key="index"
          class="list__item"
        >
          <span class="list__item--employee" @click="getRideData(item)">
            {{ item.employee.name }}
          </span>
          <span class="list__item--cc">{{ item.costCenter.name }}</span>
          <p class="list__item--text">{{ $t('Common.finishedRide') }} {{ item.costCenter.taxiCategoryName }} {{ $t('Common.of') }} {{ item.odometer | metresToKm }} {{ $t('Common.per') }} {{ item.fare | currency }} ({{ item.start.date | durationCalcPerExtensive(item.end.date) }} {{ $t('Common.of') }} <span class="text-lowercase">{{ $t('Common.duration') }}</span>).</p>
        </li>
      </ul>

      <!-- loading -->
      <transition name="fade">
        <v-layout
          v-if="isFetchingRides"
          class="py-5"
          align-center
          justify-center
        >
          <v-progress-circular color="primary" indeterminate />
        </v-layout>
      </transition>
    </div>

    <v-layout
      v-else
      class="text--center text--small"
      :style="`height: ${height}px;`"
      align-center
      justify-center
      fill-height
    >
      <div>
        <p><strong v-html="$t(`${namespace}.empty`)" /></p>
        <p class="mb-0">
          <span v-html="$t(`${namespace}.help`)" /> <a href="https://99empresas.zendesk.com/hc/pt-br/categories/360004807054-Como-utilizar-o-aplicativo-da-99-e-o-Voucher-Corporativo-" :title="$t('Common.clickHere')" target="_blank" class="text--link accent--text">{{ $t('Common.clickHere') }}</a>&nbsp;<span v-html="$t(`${namespace}.andKnowHow`)" />
        </p>
      </div>
    </v-layout>
  </div>
</template>

<script>
import { isValidArray } from 'corp-front-vue-commons/src/utils/functions'
import { STATUS_SUCCESS } from 'utils/constants'

export default {
  name: 'Success',
  props: {
    status: {
      type: Number
    },
    isFetchingRides: {
      type: Boolean
    },
    height: {
      type: [String, Number]
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isSuccess () {
      return this.status === STATUS_SUCCESS
    }
  },
  data () {
    return {
      namespace: 'Components.LatestRides'
    }
  },
  methods: {
    isValidArray (val) {
      return isValidArray(val)
    },

    getRideData (data) {
      this.$emit('getRideData', data)
    },

    loadMore (event) {
      this.$emit('loadMore', event)
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  height: 230px;
  overflow: auto;
}

.list {
  list-style: none;
  padding-left: 0;
}

.list__item {
  border-bottom: 1px solid $gray-4;
  padding: 16px 0;

  &:last-child {
    border-bottom: none;
  }
}

.list__item--employee {
  color: $accent;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.list__item--cc,
.list__item--text {
  font-size: $base-font-size - 1px;
}

.list__item--cc {
  display: block;
}

.list__item--text {
  margin-bottom: 0;
}
</style>
